import Loader from "@components/global/Loader/Loader";
import { Tabs, TabsProps } from "antd";
import { useEffect, useRef } from "react";
import { useIntl } from "react-intl";
import styles from "./MinerRowMore.module.scss";
import MinerRowMoreSettings from "./MinerRowMoreSettings/MinerRowMoreSettings";
import MinerRowMoreChart from "./MinerRowMoreChart";
import useMinerRowMoreControl from "./MinerRowMore.control";
import MinerRowMoreControl from "./MinerRowMoreControl/MinerRowMoreControl";
import { WarningOutlined } from "@ant-design/icons";

interface IMinerRowMoreProps {
  isOpen?: boolean;
  className?: string;
  stateChanged?: (value: boolean) => void;
}

function MinerRowMore(props: IMinerRowMoreProps) {

  const { formatMessage } = useIntl();
  const control = useMinerRowMoreControl();
  const isInitialMount = useRef(true);


  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else if (props.isOpen !== control.isOpen) {
      control.toggleMiner();
    }
  }, [props.isOpen]);

  useEffect(() => props.stateChanged?.(control.isOpen), [control.isOpen]);

  if (!control.isOpen) {
    return (<></>);
  }

  if (control.isLoading) {
    return (
      <div className={styles.loader}>
        <Loader transparent />
      </div>
    );
  }

  type TTabs = TabsProps["items"];

  const tabs: TTabs = [
    {
      label: formatMessage({ id: "machines.more.individualChart" }),
      key: `miner_chart_${control.minerId}`,
      children: <MinerRowMoreChart />,
    },
    {
      label: formatMessage({ id: "machines.more.settings" }),
      key: `miner_settings_${control.minerId}`,
      children: <MinerRowMoreSettings />,
    },
    {
      label: <>
        {formatMessage({ id: "machines.more.control" })}
        {control.hasErrors && (<>&nbsp;<WarningOutlined twoToneColor="#ff0000" /></>)}
      </>,
      key: `muner_control_${control.minerId}`,
      children: <MinerRowMoreControl />
    }
  ];

  return (
    <div className={styles.more_data}>
      <Tabs
        size="middle"
        items={tabs}
      />
    </div >
  );

}


export default MinerRowMore;
